/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetBrandSquareOnlineSiteMappingsRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {GetBrandSquareOnlineSiteMappingsResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const getBrandSquareOnlineSiteMappings = (request: GetBrandSquareOnlineSiteMappingsRequest, options?: CashRequestOptions) => post<GetBrandSquareOnlineSiteMappingsRequest, GetBrandSquareOnlineSiteMappingsResponse>("/2.0/cash/get-brand-square-online-site-mappings", request, {...options, rejectOnError: true })